import { UploadIcon } from '@/components/Icons/UploadIcon';
import clsx from 'clsx';

interface FileUploadContentProps {
  backgroundColor?: string;
  fontSize?: number;
  label?: string;
}

const FileUploadContent = ({
  backgroundColor = 'transparent',
  fontSize = 14,
  label,
}: FileUploadContentProps) => {
  return (
    <div
      className={clsx(
        // Layout
        'tw-relative tw-flex tw-flex-col tw-h-full tw-gap-3',
        // Alignment
        'tw-items-start tw-justify-center',
        // Spacing
        'tw-p-2',
        'tw-w-fill',
        // Typography
        'tw-font-sans tw-leading-tight tw-text-slate-700',
      )}
      style={{ backgroundColor, fontSize: `${fontSize}px` }}
      data-name="FileUploadContent"
    >
      <div className="tw-flex tw-items-center tw-gap-2">
        <UploadIcon className="tw-h-4 tw-w-4" />
        <span className="tw-font-sans tw-font-medium tw-text-slate-700 tw-truncate">
          {label || 'File Upload'}
        </span>
      </div>
      <div className="tw-flex tw-w-fill tw-items-center tw-justify-start tw-gap-2 tw-rounded-md tw-border tw-border-solid tw-border-gray-200 tw-bg-gray-50 tw-p-2">
        <div className="tw-flex tw-h-7 tw-w-7 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded tw-bg-[#E5F2FF]">
          <UploadIcon className="tw-h-5 tw-w-5 tw-text-primary" />
        </div>
        <div className="tw-flex-grow tw-truncate tw-text-left">
          <p className="tw-font-medium tw-text-slate-700">
            Click to upload
          </p>
          <p className="tw-mt-1 tw-text-slate-500 ">
            Maximum file size: 10 MB
          </p>
        </div>
      </div>
    </div>
  );
};

export default FileUploadContent;

